/* unplugin-vue-components disabled */import script from "./otherCallbackUrl.vue?vue&type=script&setup=true&lang=ts"
export * from "./otherCallbackUrl.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__